import { render, staticRenderFns } from "./TermsOfService1123038.vue?vue&type=template&id=1e7d2540&scoped=true&"
import script from "./TermsOfService1123038.vue?vue&type=script&lang=js&"
export * from "./TermsOfService1123038.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfService1123038.vue?vue&type=style&index=0&id=1e7d2540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7d2540",
  null
  
)

export default component.exports